import type { FC } from 'react'
import { InfoBlock } from '../components/InfoBlock/InfoBlock'
import { selectAuthError } from '../features/auth/selectors/authSelectors'
import { useAppSelector } from '../hooks'

const LoginErrorPage: FC = () => {
  const authError = useAppSelector(selectAuthError)

  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '300px', gap: 16 }}>
      <InfoBlock
        title="Login Error"
        description={authError?.message ?? 'Could not complete login. Please try again.'}
      />
    </div>
  )
}

export default LoginErrorPage
